<template>
  <div></div>
</template>

<script>
  export default {
    data () {
      return {
        pay_mode: '',
        order_id: '',
        type: ''
      }
    },
    created () {
      this.pay_mode = this.$route.query.pay_mode
      this.order_id = this.$route.query.order_id
      this.type = this.$route.query.type
      this.wxpayOrder()
    },
    methods: {
      wxpayOrder () {
        this.$http.post('/apipx/order/pay', {
          token: JSON.parse(localStorage.getItem('login')).token,
          pay_mode: this.pay_mode,
          order_id: this.order_id,
          type: 'course_order'
        }).then(res => {
          if (res.code === 0) {
            document.write(res.data)
          }
        })
      }
    }
  }
</script>

<style type="text/scss" lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/CourseDetails/applay.vue